// TODO fix to CamelCase
export const configListKeys = [
  'clientId',
  'authUrl',
  'backendUrl',
  'redirectUri',
  'postLogoutUri',
  'scope',
  'headers',
  'webCurtainLoginType',
  'cid',
  'session_id',
  'appmetrica_device_id',
  'product_name',
  'keycloakEnabled',
  'keycloak_authUrl',
  'keycloak_clientId',
  'keycloak_realmName',
  'keycloak_idpName',
  'debugConsole',
  'debugTrack',
  'device',
  'sentryEnabled',
  'preventAutoStorageCleanup',
  'useStorage',
  'requestTimeout',
  'configCacheTtlDays',
  'loginTag',
  'type',
  'trackers',
];